import type { Id } from '@e-socna/data-layer';

type OptionableGroup = Readonly<{ _id: Id; isOptional?: boolean }>;

// Same rule as the back (retained-service-usages-groups.util): the mandatory
// groups plus the chosen options; without a choice, every option.
export const filterRetainedServiceUsagesGroups = <G extends OptionableGroup>(
  groups: readonly G[],
  selectedOptionGroupIds: readonly Id[] | null | undefined,
): readonly G[] =>
  groups.filter(
    (group) =>
      !group.isOptional ||
      !selectedOptionGroupIds ||
      selectedOptionGroupIds.includes(group._id),
  );

// Same rule as the back: the choice is stored as the rejected options, so
// that an option added later is retained; the selected options are the other
// optional groups, null (every option) while none is rejected.
export const selectedOptionGroupIdsOf = (
  groups: readonly OptionableGroup[],
  rejectedOptionGroupIds: readonly Id[] | null | undefined,
): readonly Id[] | null =>
  rejectedOptionGroupIds?.length
    ? groups
        .filter(
          (group) =>
            group.isOptional && !rejectedOptionGroupIds.includes(group._id),
        )
        .map((group) => group._id)
    : null;
